<a class="text-button" [class.primary]="isPrimary" [class.accent]="isAccent">
    <ng-content></ng-content>
</a>